import {
    Box,
    Heading,
    Icon,
    List,
    ListIcon,
    ListItem,
    Stack,
    Table,
    Tbody,
    Td,
    Tr
} from "@chakra-ui/react";
import React, { useState } from "react";
import { MdAdd, MdLink, MdSettings, MdStar } from "react-icons/md";
import { useParams } from "react-router";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { CityForm, ICreateCityValues } from "../../forms";
import { useCallQuery } from "../../graphql";
import { formatDate } from "../../utils";

export const Rating = ({
    size,
    scale = 5,
    fillColor,
    strokeColor,
    value = 0
}) => {
    return (
        <Stack isInline>
            { Array.from({ length: value }).map(() => (
                <MdStar color={ fillColor } size={ size } />
            )) }

            { Array.from({ length: scale - value }).map(() => (
                <MdStar color={ strokeColor } size={ size } />
            )) }
        </Stack>
    );
};

const CallDetails: React.FC = () => {
    const { id } = useParams<{ id: string }>();

    const { data, loading } = useCallQuery({
        variables: {
            id: +id
        }
    });

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <Box borderWidth="1px" borderRadius="lg" background="#FFF" p="10px">
                <Title title="Detajet e telefonatës"></Title>

                <Table variant="simple">
                    <Tbody>
                        <Tr>
                            <Td width="45%" isNumeric>
                                Data e kërkimit
                            </Td>
                            <Td>{ formatDate(data.call.requestTime) }</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Data e fillimit</Td>
                            <Td>{ formatDate(data.call.startTime) }</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Data e përfundimit</Td>
                            <Td>{ formatDate(data.call.endTime) }</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Kohëzgjatja</Td>
                            <Td>{ data.call.duration } minuta</Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Pjesëmarrës</Td>
                            <Td>
                                <List spacing={ 3 }>
                                    { data.call.participants.map((p, i) => (
                                        <ListItem key={ i }>
                                            <AccountAvatar account={ p.account } />
                                        </ListItem>
                                    )) }
                                </List>
                            </Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Rregjistrime</Td>
                            <Td>
                                <List spacing={ 3 }>
                                    { data.call.recordings.map((r, i) => {
                                        return (
                                            <ListItem key={ i }>
                                                <ListIcon as={ MdLink } color="blue.500" />

                                                <a href={ r }>Lidhja { i + 1 }</a>
                                            </ListItem>
                                        );
                                    }) }
                                </List>
                            </Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Vlerësimi</Td>
                            <Td>
                                <Rating
                                    size={ 22 }
                                    scale={ 5 }
                                    fillColor="gold"
                                    strokeColor="grey"
                                    value={ data.call?.review?.rating }
                                />
                            </Td>
                        </Tr>
                        <Tr>
                            <Td isNumeric>Koment</Td>
                            <Td>{ data.call?.review?.description } </Td>
                        </Tr>
                    </Tbody>
                </Table>
            </Box>
        </>
    );
};

export default CallDetails;
